export class Warnings {
  private warnings: string[] = [];

  public add(warning: string) {
    this.warnings.push(warning);
  }

  public getWarnings() {
    return this.warnings;
  }

  public hasWarnings() {
    return this.warnings.length > 0;
  }

  public toString() {
    return this.warnings.join('\n');
  }
}
